/**************************************************
 * Nombre:       BarraPc
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, InputAdornment, TextField, Typography} from "@mui/material";
import logo from '../../Recursos/logo_color.svg'
import {SECCIONES} from "../../Constantes";
import {theme} from "../../Tema";
import {Search, ShoppingCart} from '@mui/icons-material'
import {useNavigate} from "react-router";
import {useIrRuta} from "../../Utilidades/useIrRuta";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import {useProductosCarrito} from "../../Modulo_Carrito_Flotante/Funcionamiento/Hooks/useProductosCarrito";
import {obtenerValorTotal} from "../../Modulo_Carrito_Flotante/Formularios/Formulario_Lista_Productos";
import {useCarritoFlotante} from "../../Modulo_Carrito_Flotante/Hooks/useCarritoFlotante";
import {useState} from "react";


const BarraPc = ({esVerde}) => {
    const navigate = useNavigate();
    const {ir} = useIrRuta()
    const {productos} = useProductosCarrito()
    const {Carrito, abrir} = useCarritoFlotante()
    const [palabra, setPalabra] = useState('')


    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{backgroundColor: !esVerde ? '#EDFCF6' : '#00000000'}}
        >

            <Carrito/>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, py: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'space-between'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <img
                            onClick={() => navigate('/Home')}
                            src={logo} width={120} height={'auto'} style={{cursor: 'pointer'}}/>

                        {SECCIONES.map((it, index) => {
                            return (
                                <Typography
                                    onClick={() => ir(it)}
                                    sx={{
                                        transition: 'all .2s ease-in-out',
                                        fontWeight: 600,
                                        fontSize: 16,
                                        borderBottom: 2,
                                        cursor: 'pointer',
                                        borderColor: '#ffffff00',
                                        "&:hover": {
                                            borderColor: theme.palette.primary.main,
                                        }

                                    }}>
                                    {it}
                                </Typography>
                            )
                        })}

                    </Grid>

                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-end'}}>
                    <Grid
                        container
                        justifyContent={'flex-end'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={2}
                    >

                        <TextField
                            size={'small'}
                            label={'Buscar producto'}
                            fullWidth={false}
                            sx={{width: 300}}
                            value={palabra}
                            onChange={e => setPalabra(e.target.value)}
                            onKeyPress={(e) =>{
                                if (e.key === 'Enter'){
                                    navigate('/Resultados/Palabra/' + palabra)
                                }
                            }}
                            slotProps={{
                                input: {
                                    endAdornment: (

                                        <InputAdornment position="end"
                                                        onClick={() => {
                                                            navigate('/Resultados/Palabra/' + palabra)
                                                        }}
                                                        sx={{cursor: 'pointer'}}
                                        >
                                            <Search color={'primary'}/>
                                        </InputAdornment>
                                    ),
                                    disableUnderline: true,
                                    sx: {borderRadius: 10}
                                },
                                inputLabel: {
                                    sx: {marginLeft: 0, borderRadius: 10}
                                }
                            }
                            }
                        />

                        <Button
                            onClick={() => abrir()}
                            variant={'text'} startIcon={<ShoppingCart/>}
                            sx={{color: '#000', fontWeight: 600}}
                        >
                            {formatoMoneda(obtenerValorTotal(productos))}
                        </Button>

                    </Grid>

                </Grid>


            </Grid>

        </Grid>
    )

}
export default BarraPc    